import { EDUCATION } from "@data/education";
import useTranslations from "@hooks/useTranslations";
import { localize } from "@utils/i18n";
import { useLanguage } from "@contexts/LanguageContext";
import { ICONS } from "@utils/icons";

const Education = () => {
  const t = useTranslations();
  const { lang } = useLanguage();

  return (
    <div className="col-12" data-section="education">
      <div className="bostami-section-title-wrap mb-20">
        <h4 className="section-title">
          <i className={ICONS.education} />
          {t.cv.education}
        </h4>
      </div>
      <div className="bostami-card-wrap">
        {EDUCATION.map((element) => {
          const item = localize(element, lang);
          return (
            <div
              className="bostami-card-item bg-prink mb-20"
              key={`${element.parcours}-${element.anneeDebut}-${element.anneeFin}`}
            >
              <span className="card-subtitle">
                {item.anneeDebut}-{item.anneeFin}
              </span>
              <h6 className="card-title">
                {item.parcours} <span>- {item.etablissement},</span>
              </h6>
              <p className="card-text">{item.lieu}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Education;
